export const mappingChannelOfferForLabraUI = {
  Buyer: 'buyer',
  Authorization: 'authorizationName',
  'Expiry date': 'expiryDate',
  Type: 'type',
  Status: 'offerStatus',
  'Offer ID': 'offerId',
  '': 'actions',
}

export const CHANNEL_OFFER_READ_ONLY_PERMISSION_MESSAGE =
  'This action is disabled because you have read-only access'
